<template>
  <NuxtLink
    class="hero-banner-detailed-entry"
    :to="entry.cta.url" :external="true"
  >
    <div
      class="flex flex-col gap-2 sm:gap-4 order-2 sm:order-1 justify-between sm:justify-center p-4 pt-0 sm:p-8 h-full"
    >
      <div class="flex flex-col h-full">
        <div class="flex flex-col gap-2 px-4 grow justify-center">
          <StartpageHeroElementBadges :badges="entry.badges" />
          <BasicBtErrorBoundary>
            <div v-if="entry.brandId">
              <ArticleExpBrand
                :enable-link="true"
                :img-class="'max-h-8'"
                :brand-id="entry.brandId"
                :show-logo="true"
              />
            </div>
          </BasicBtErrorBoundary>
          <div
            v-if="entry.headline"
            class="sm:leading-normal leading-6 line-clamp-2 text-2xl sm:text-xl lg:text-4xl font-extrabold"
            :class="entry.headlineOrange ? 'text-primary':'text-paragraph'"
            v-text="entry.headline"
          />
          <div
            v-if="entry?.description"
            class="leading-normal lg:line-clamp-5 text-sm lg:text-2xl"
            :class="entry.brandId || (entry.badges && entry.badges.length > 0) ? 'line-clamp-2' : 'line-clamp-5'"
            v-text="entry?.description"
          />
          <div v-if="entry.timedOffer && allowCountDown == true">
            <StartpageHeroElementCountdown
              class="py-8"
              :message="entry.timedOfferText ?? 'Die Angebote enden in'"
              :label-text-day="'Tagen'"
              :label-text-hour="'Stunden'"
              :label-text-minute="'Minuten'"
              :label-text-seconds="'Sekunden'"
              :timed-offer="entry.timedOffer"
              @invalid-countdown="allowCountDown = false"
            />
          </div>
        </div>
        <div v-if="entry.cta.url && entry.cta.label">
          <div
            class="text-center font-bold text-sm text-primary-contrast bg-primary rounded-full py-3 w-full sm:w-auto"
            v-text="entry.cta.label"
          />
        </div>
      </div>
    </div>
    <div
      v-if="entry.images.secondary"
      class="flex flex-col justify-center h-full items-center order-1 sm:order-2 bg-no-repeat bg-cover bg-center"
    >
      <div v-if="entry.images.secondary.lg && (entry.images.secondary.lg.alt || entry.altText || entry?.description)" class="flex h-full items-center justify-center" >
        <img fetchpriority="high" class="h-full" :src="entry.images.secondary.lg.url" :alt="entry.images.secondary.lg.alt && entry.images.secondary.lg.alt != '' ? entry.images.secondary.lg.alt : entry.altText && entry.altText != '' ? entry.altText : entry?.description">
      </div>
    </div>
  </NuxtLink>
</template>
<script setup lang="ts">
import type { SliderEntry } from '../../SliderStructure';
defineProps<{
  entry: SliderEntry;
}>();

const allowCountDown = ref(true);
</script>
<style lang="postcss" scoped>
  .hero-banner-detailed-entry {
    @apply rounded-3xl overflow-hidden items-center h-full grid grid-rows-2 sm:grid-rows-1 sm:grid-cols-2  gap-4 bg-white;
  }
</style>
